module.exports = __webpack_public_path__ + "f2abaa455f7d09d13eb18fd8ec5da7a1.MP3";